import determineSegmentIndex from './determineSegmentIndex';
import dynamicThreshold from './dynamicThreshold';
import erase from './erase';
import islandRemoval from './islandRemoval';
import preview from './preview';
import regionFill from './regionFill';
import setValue from './setValue';
import threshold from './threshold';

export default {
  determineSegmentIndex,
  dynamicThreshold,
  erase,
  islandRemoval,
  preview,
  regionFill,
  setValue,
  threshold,
};
